//@flow
import * as actionTypes from './actionTypes';
import reduce from '../reduce';
import type { ReducerState$Type,Action } from './flowTypes'

const initialState:ReducerState$Type = {
    error: '',
    invoiceSubmitted: false,
    hermesResultset: null,
    anyChanges: false,
    formData: {},
    reviewQuestions: [],
    formError: {},
    hermesVendors: [],
    hermesVendorsLoaded: false,
}

//In use : actionTypes.HERMES_INV_SUBMIT_SUCCESS
const invoiceSubmittedSuccess = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: true,
        error: ''
    }
}
//In use : actionTypes.
const invoiceSubmittedError = (state:ReducerState$Type,action:Action) => {
    return {
        ...state,
        error: action.error
    }
}

//actionTypes.INV_SUBMITTED_COMPLETED
const invSubmittedCompleted = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

const editVerifyFormDataSuccess=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        reviewQuestions: action.reviewQuestions
    }
}

const editVerifyFormDataError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: action.error
    }
}

const updateFormError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        formError: action.formError
    }
}

const refreshedHermesVendors=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        hermesVendors: action.hermesVendors,
        hermesVendorsLoaded: true
    }
}

const refreshedHermesVendorsError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.HERMES_INV_SUBMITTED_COMPLETED]: invSubmittedCompleted,
    [actionTypes.HERMES_INV_SUBMIT_SUCCESS]: invoiceSubmittedSuccess,
    [actionTypes.HERMES_INV_SUBMIT_ERROR]: invoiceSubmittedError,
    [actionTypes.HERMES_EDIT_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess,
    [actionTypes.HERMES_EDIT_VERIFY_FORM_DATA_ERROR]: editVerifyFormDataError,
    [actionTypes.HERMES_UPDATE_FORM_ERROR]: updateFormError,
    [actionTypes.REFRESH_HERMES_VENDORS_SUCCESS]: refreshedHermesVendors,
    [actionTypes.REFRESH_HERMES_VENDORS_ERROR]: refreshedHermesVendorsError
});


// WEBPACK FOOTER //
// ./src/redux/hermes/reducer.js